import './umuVideoSelector.scss';
import React, { useEffect, useState, useRef } from 'react';
import { lang } from '@umu/ukit-lang';
import { If, Loading } from 'common/src/components';
import { defaultPageInfo } from 'common/src/config';
import { ListBlankPC, PaginationV2 } from 'businessCommon/src/components';
import { Modal, Iconfont, Tooltip, Button, Checkbox } from '@umu/umu-design';
import { getResourceArr, IMediaData } from '@umu/umu-api/src/services/resource/getResourceArr';
import ImageImageHandle from '@umu/umu-image-handle';
export type { IMediaData };

interface IUmuVideoSelectorProps {
    visible?: boolean;
    allowUpload?: boolean;
    status_str?: string;
    btnType?: 'primary' | 'primary-blue';
    isMulti?: boolean;
    cancel?: VoidFunction;
    done(files: IMediaData[]): void;
}
const { confirm } = Modal;
const formatFileSize = function (text: string) {
    let length = parseInt(text, 10);
    if (length < 1024) {
        return length + 'B';
    }
    const size = ['B', 'KB', 'MB', 'GB', 'TP', 'PB', 'EB'];
    let prettyText = 0;

    let sizeCount = 0;
    const sizeCountLength = size.length;
    while (length > 1 && sizeCount < sizeCountLength) {
        sizeCount = sizeCount + 1;
        prettyText = Math.round(length * 100) / 100;
        length = length / 1024;
    }

    return parseFloat(prettyText.toFixed(1)) + size[sizeCount - 1];
};

const uplinkText = lang(
    `暂不支持上传视频，如需本地上传，请先从 <a href="/videoDrive#/?mode=list" target="_blank">课程资源 - 我的音视频</a> 中上传。`,
);

function getThumbImg(file: IMediaData) {
    const thumbImg = (file.thumb_info || '').split(',')[0];
    if (!thumbImg) {
        return '';
    }
    if (file.id) {
        return ImageImageHandle.preSignedUnbindUrl(
            ImageImageHandle.appendWidth(thumbImg, 100),
            file.id,
            ImageImageHandle.SOURCE_TYPE.TYPE_VIDEO,
        );
    }
    return '';
}
export const UmuVideoSelectorPCPage = (props: IUmuVideoSelectorProps) => {
    const {
        status_str = 'in_use,transcoding,wait_transcoding',
        allowUpload = false,
        isMulti = false,
        done,
        btnType = 'primary',
    } = props;
    const [order, setOrder] = useState({
        is_desc: 1,
        order_by: 'create_time',
    });
    const keywordsRef = useRef('');
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState<IMediaData[]>([]);
    const [selectedFiles, setSelectedFiles] = useState<IMediaData[]>([]);
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);

    useEffect(() => {
        doSearch(1);
    }, [order]);

    const doSearch = (page: number) => {
        setLoading(true);
        getResourceArr({
            page,
            page_rows: 10,
            status_str,
            ext_type: 'mp4',
            is_desc: order.is_desc,
            order_by: order.order_by,
            media_type: 'videoweike',
            search_keyword: keywordsRef.current,
        })
            .then((res) => {
                if (!res.error_code) {
                    setFiles(res.data.list);
                    setPageInfo(res.data.page_info);
                }
            })
            .finally(() => setLoading(false));
    };

    const onKeywordSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        const newValue = new FormData(e.target as HTMLFormElement).get('keyword');
        keywordsRef.current = newValue as string;
        doSearch(1);
        e.cancelable = false;
        e.preventDefault();
        return false;
    };
    const onKeywordChange = (e: any) => {
        if (e?.target?.name === 'keyword') {
            keywordsRef.current = e?.target?.value || '';
        }
    };
    const orderChange = (orderName: string) => {
        if (orderName === order.order_by) {
            setOrder({
                is_desc: order.is_desc === 0 ? 1 : 0,
                order_by: orderName,
            });
        } else {
            setOrder({
                is_desc: 0,
                order_by: orderName,
            });
        }
    };

    const isDisabled = (file: IMediaData) => {
        return file.status !== 'in_use';
    };

    const selectFile = (file: IMediaData, isActive: boolean) => {
        if (isDisabled(file)) {
            !isMulti && setSelectedFiles([]);
            return;
        }
        let newSelecteds = selectedFiles;
        if (isActive) {
            newSelecteds = selectedFiles.filter((item) => item.id !== file.id);
        } else {
            if (isMulti) {
                newSelecteds = [...selectedFiles, file];
            } else {
                newSelecteds = [file];
            }
        }
        setSelectedFiles(newSelecteds);
    };

    const renderTrs = () => {
        return files.map((file) => {
            const thumbImg = getThumbImg(file);
            const isActive = selectedFiles.findIndex((item) => item.id === file.id) !== -1;
            return (
                <tr
                    key={file.id || file.url}
                    className={`file-item file-item-row file-item-type-mp4 ${isActive ? 'active' : ''} ${
                        file.transcoding_url ? 'can-select' : ''
                    }`}
                    onClick={() => selectFile(file, isActive)}
                >
                    <td>
                        <div className="title title-course">
                            <div className="file-name flex--start--center">
                                <div className="file-name-img flex--center">
                                    <If condition={!!thumbImg}>
                                        <img className="thumb-img" src={thumbImg} />
                                    </If>
                                </div>
                                <Tooltip overlayClassName="umu-video-selector__file-name-text" title={file.file_name}>
                                    <div className="file-name__name flex--1 umu-text-clamp clamp-1">
                                        {file.file_name}
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    </td>
                    <td className="file-item-col date-time file-time">{file.create_time}</td>
                    <td className="file-item-col size">{formatFileSize(file.file_size)}</td>
                    <If condition={isMulti}>
                        <td className="file-item-col coopreation">
                            <Checkbox checked={isActive} disabled={isDisabled(file)} />
                        </td>
                    </If>
                </tr>
            );
        });
    };

    const renderFooter = () => {
        return (
            <div className="umu-video-selector__footer flex--between--center">
                <div className="flex--1">
                    <div className="flex--start--center">
                        <div className="total-text">{lang('共 {$0{0= 条,1= 条}}', pageInfo.list_total_num)}</div>
                        <If condition={pageInfo.total_page_num > 1}>
                            <div className="flex--1">
                                <PaginationV2
                                    showSizeChanger
                                    pageOffset={pageInfo.total_page_num > 100 ? 2 : 4}
                                    currentPage={pageInfo.current_page}
                                    maxPage={pageInfo.total_page_num}
                                    onPageChange={doSearch}
                                />
                            </div>
                        </If>
                    </div>
                </div>
                <div className="umu-video-selector__footer__operations flex--center">
                    <Iconfont
                        type="RefreshHalfCircle"
                        className="umu-video-selector__footer__operations__refresh flex--center"
                        onClick={() => doSearch(1)}
                    />
                    <Button type={btnType} disabled={!selectedFiles.length} onClick={() => done(selectedFiles!)}>
                        {lang('选择')}
                    </Button>
                </div>
            </div>
        );
    };

    return (
        <div className="umu-video-selector">
            <If condition={!allowUpload}>
                <div className="umu-video-selector__uplink" dangerouslySetInnerHTML={{ __html: uplinkText }} />
            </If>
            <form
                onSubmit={onKeywordSubmit}
                onChange={onKeywordChange}
                className="umu-video-selector__filter flex--start--center"
            >
                <input
                    type="text"
                    name="keyword"
                    className="umu-video-selector__filter__keyword"
                    placeholder={lang('文件名称')}
                />
                <Button type={btnType} iconName="Search" className="btn-search" onClick={() => doSearch(1)} />
            </form>
            <div className="file-list-wrap">
                <If condition={!loading && !!files.length}>
                    <table>
                        <thead>
                            <tr className="file-item file-item-header">
                                <th
                                    className={`file-item-col icon-activatable title ${order.is_desc ? 'active' : ''}`}
                                    onClick={() => orderChange('file_name')}
                                >
                                    <span>{lang('文件名称')}</span>
                                    <If condition={order.order_by === 'file_name'}>
                                        <i className="icon icon-arrow arrow3 up"></i>
                                    </If>
                                </th>
                                <th
                                    className={`file-item-col icon-activatable date-time ${
                                        order.is_desc ? 'active' : ''
                                    }`}
                                    onClick={() => orderChange('create_time')}
                                >
                                    {lang('上传时间')}
                                    <If condition={order.order_by === 'create_time'}>
                                        <i className="icon icon-arrow arrow3 up"></i>
                                    </If>
                                </th>
                                <th
                                    className={`file-item-col icon-activatable size ${order.is_desc ? 'active' : ''}`}
                                    onClick={() => orderChange('file_size')}
                                >
                                    <span>{lang('文件大小')}</span>
                                    <If condition={order.order_by === 'file_size'}>
                                        <i className="icon icon-arrow arrow3 up"></i>
                                    </If>
                                </th>
                                <If condition={isMulti}>
                                    <th className="file-item-col coopreation">{lang('操作')}</th>
                                </If>
                            </tr>
                        </thead>
                        <tbody>{renderTrs()}</tbody>
                    </table>
                </If>
                <Loading show={loading} />
                <If condition={!loading && !files.length}>
                    <ListBlankPC
                        type={keywordsRef.current ? 4 : 2}
                        title={keywordsRef.current ? lang('没有找到符合条件的音视频') : lang('暂无数据')}
                    />
                </If>
            </div>

            {renderFooter()}
        </div>
    );
};
export const UmuVideoSelectorPC = (props: IUmuVideoSelectorProps) => {
    const { visible = true, ...rest } = props;

    return (
        <Modal
            closable
            centered
            width={800}
            visible={visible}
            maskClosable={false}
            title={lang('我的音视频')}
            onCancel={props.cancel}
            wrapClassName="umu-video-selector-modal"
            cancelText=""
            okText=""
        >
            <UmuVideoSelectorPCPage {...rest} />
        </Modal>
    );
};
export const onDialogUmuVideoSelectorPC = (data: IUmuVideoSelectorProps) => {
    const dialog = confirm({
        centered: true,
        closable: true,
        width: 860,
        title: lang('我的音视频'),
        wrapClassName: 'umu-video-selector-modal',
        maskClosable: false,
        cancelText: '',
        okText: '',
        content: (
            <UmuVideoSelectorPCPage
                {...data}
                cancel={() => {
                    data.cancel?.();
                    dialog.destroy();
                }}
                done={(val) => {
                    data.done(val);
                    dialog.destroy();
                }}
            />
        ),
    });
    return dialog;
};
